import { Link } from 'react-router-dom';
import { IconBolt, IconClock, IconShield } from '@/components/landing/LandingIcons';
import { StoreBadgeImages } from '@/components/shared/StoreBadges';
import { Button } from '@/components/ui/Button';
import { PUBLIC_ANCHORS, ROUTES } from '@/constants/routes';

const networks = [
  { name: 'MTN', logo: '/assets/networks/mtn.png' },
  { name: 'Airtel', logo: '/assets/networks/airtel.png' },
  { name: 'Glo', logo: '/assets/networks/glo.png' },
  { name: '9mobile', logo: '/assets/networks/9mobile.png' },
];

const trustBadges = [
  { label: 'Instant Delivery', icon: IconBolt },
  { label: '100% Secure', icon: IconShield },
  { label: '24/7 Available', icon: IconClock },
];

export function HeroSection() {
  return (
    <section id="home" className="relative overflow-hidden bg-hero-glow">
      <div className="container-page grid items-center gap-12 py-16 lg:grid-cols-2 lg:py-24">
        <div>
          <span className="inline-flex items-center rounded-full border border-primary/20 bg-primary/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-primary">
            Nigeria&apos;s #1 VTU Platform
          </span>

          <h1 className="mt-5 text-4xl font-extrabold leading-tight tracking-tight text-brand-navy sm:text-5xl lg:text-6xl">
            Recharge <span className="text-primary">Airtime</span> &{' '}
            <span className="text-secondary">Data</span> Instantly
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-brand-muted sm:text-lg">
            Buy airtime, data bundles, pay for cable TV subscriptions, utility bills, and education pins at unbeatable rates. Fast, reliable, and secure.
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            {trustBadges.map(({ label, icon: Icon }) => (
              <span
                key={label}
                className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-2 text-xs font-semibold text-brand-navy shadow-sm"
              >
                <Icon className="h-4 w-4 text-primary" />
                {label}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-4">
            <Link to={ROUTES.register}>
              <Button size="lg">Get Started</Button>
            </Link>
            <a href={PUBLIC_ANCHORS.services}>
              <Button size="lg" variant="outline">
                Explore Services
              </Button>
            </a>
          </div>

          <div className="mt-8">
            <p className="text-sm font-semibold text-brand-navy">Get our app</p>
            <StoreBadgeImages className="mt-3" />
          </div>

          <div className="mt-10">
            <p className="text-sm font-semibold text-brand-navy">Supported Networks</p>
            <div className="mt-3 flex flex-wrap gap-3">
              {networks.map((network) => (
                <div
                  key={network.name}
                  className="flex items-center gap-2 rounded-xl border border-gray-100 bg-white px-3 py-2 shadow-sm"
                >
                  <img src={network.logo} alt={network.name} className="h-7 w-7 object-contain" />
                  <span className="text-xs font-semibold text-brand-navy">{network.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="relative mx-auto w-full max-w-md lg:max-w-lg">
          <div className="absolute -left-4 top-8 z-10 rounded-full bg-secondary px-4 py-2 text-sm font-semibold text-white shadow-lg">
            Best Rates!
          </div>
          <div className="rounded-3xl border border-gray-100 bg-white p-8 shadow-card">
            <img
              src="/assets/logo-dark.jpeg"
              alt="AS DataLink"
              className="mx-auto h-44 w-44 rounded-2xl object-cover shadow-soft ring-4 ring-brand-surface"
              width={176}
              height={176}
            />
            <p className="mt-6 text-center text-xl font-bold text-brand-navy">AS DATALINK</p>
            <p className="text-center text-sm text-brand-muted">Your trusted VTU partner</p>
          </div>
          <div className="absolute -bottom-3 right-0 z-10 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-white shadow-lg">
            24/7 Service
          </div>
        </div>
      </div>
    </section>
  );
}
